import { render } from "./ColorInput.vue?vue&type=template&id=4c06f934&ts=true"
import script from "./ColorInput.vue?vue&type=script&lang=ts"
export * from "./ColorInput.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__